<template>
  <form action="">
    <div class="modal-card" style="width: 960px">
      <header class="modal-card-head">
        <p class="modal-card-title">
          Details für Batch {{ batchid }} von Bibliothek {{ library }}
        </p>
      </header>
      <section class="modal-card-body">
        <b-loading
          :is-full-page="false"
          :active.sync="isLoading"
          :can-cancel="false"
        >
        </b-loading>

        <b-message v-if="apiError" type="is-danger" :closable="false">
          {{ apiError }}
        </b-message>

        <div class="box" v-if="batch">
          <table class="table is-narrow is-fullwidth">
            <tr>
              <th>Zeitstempel</th>
              <td>{{ batch.stamp }}</td>
            </tr>
            <tr>
              <th>Abgeholt</th>
              <td>{{ batch.new ? "-" : batch.stamp_dl }}</td>
            </tr>
            <tr>
              <th>Anzahl Bestellungen</th>
              <td>{{ batch.count }}</td>
            </tr>
          </table>

          <b-dropdown>
            <button
              class="button is-primary"
              slot="trigger"
              :disabled="isLoading"
            >
              <b-icon icon="download"></b-icon>
              <span>
                Herunterladen
              </span>
              <b-icon icon="menu-down"></b-icon>
            </button>
            <b-dropdown-item @click="downloadBatch('pdf')"
              >Herunterladen als PDF</b-dropdown-item
            >
            <b-dropdown-item @click="downloadBatch('html')"
              >Herunterladen als HTML</b-dropdown-item
            >
            <b-dropdown-item @click="downloadBatch('json')"
              >Herunterladen als JSON</b-dropdown-item
            >
            <b-dropdown-item @click="downloadBatch('bon')"
              >Herunterladen als BON</b-dropdown-item
            >
          </b-dropdown>
          <b-dropdown>
            <button
              class="button is-primary"
              slot="trigger"
              :disabled="isLoading"
            >
              <b-icon icon="open-in-new"></b-icon>
              <span>
                Öffnen
              </span>
              <b-icon icon="menu-down"></b-icon>
            </button>
            <b-dropdown-item @click="openBatch('pdf')"
              >Öffnen als PDF</b-dropdown-item
            >
            <b-dropdown-item @click="openBatch('html')"
              >Öffnen als HTML</b-dropdown-item
            >
            <b-dropdown-item @click="openBatch('json')"
              >Öffnen als JSON</b-dropdown-item
            >
            <b-dropdown-item @click="openBatch('bon')"
              >Öffnen als BON</b-dropdown-item
            >
          </b-dropdown>
        </div>

        <b-table
          :data="requests"
          :paginated="true"
          :per-page="10"
          :pagination-simple="true"
          :current-page.sync="currentPage"
          v-if="requests"
        >
          <b-table-column field="seqnr" label="#" v-slot="props" width="10">
            {{ props.row.seqnr }}
          </b-table-column>
          <b-table-column field="reqid" label="Nummer" v-slot="props">
            {{ props.row.reqid }}
          </b-table-column>
          <b-table-column field="stamp" label="Zeitstempel" v-slot="props">
            {{ props.row.stamp }}
          </b-table-column>
          <b-table-column field="ppn" label="PPN" v-slot="props">
            {{ props.row.ppn }}
          </b-table-column>
          <b-table-column field="requester" label="Bibliothek" v-slot="props">
            {{ props.row.requester }}
          </b-table-column>
          <b-table-column field="action" width="150" v-slot="props">
            <b-dropdown position="is-bottom-left">
              <button
                class="button is-light is-small"
                slot="trigger"
                :disabled="isLoading"
              >
                <b-icon icon="download"></b-icon>
                <b-icon icon="menu-down"></b-icon>
              </button>
              <b-dropdown-item @click="downloadRequest(props.row.reqid, 'pdf')"
                >Herunterladen als PDF</b-dropdown-item
              >
              <b-dropdown-item @click="downloadRequest(props.row.reqid, 'html')"
                >Herunterladen als HTML</b-dropdown-item
              >
              <b-dropdown-item @click="downloadRequest(props.row.reqid, 'json')"
                >Herunterladen als JSON</b-dropdown-item
              >
              <b-dropdown-item @click="downloadRequest(props.row.reqid, 'bon')"
                >Herunterladen als BON</b-dropdown-item
              >
            </b-dropdown>
            <b-dropdown position="is-bottom-left">
              <button
                class="button is-light is-small"
                slot="trigger"
                :disabled="isLoading"
              >
                <b-icon icon="open-in-new"></b-icon>
                <b-icon icon="menu-down"></b-icon>
              </button>
              <b-dropdown-item @click="openRequest(props.row.reqid, 'pdf')"
                >Öffnen als PDF</b-dropdown-item
              >
              <b-dropdown-item @click="openRequest(props.row.reqid, 'html')"
                >Öffnen als HTML</b-dropdown-item
              >
              <b-dropdown-item @click="openRequest(props.row.reqid, 'json')"
                >Öffnen als JSON</b-dropdown-item
              >
              <b-dropdown-item @click="openRequest(props.row.reqid, 'bon')"
                >Öffnen als BON</b-dropdown-item
              >
            </b-dropdown>
          </b-table-column>
          <template slot="empty">
            <section class="section">
              <div class="content has-text-grey has-text-centered">
                <p>Keine Daten vorhanden</p>
              </div>
            </section>
          </template>
        </b-table>
      </section>
      <footer class="modal-card-foot">
        <button
          class="button is-primary"
          type="button"
          @click="$parent.close()"
        >
          <b-icon icon="window-close"></b-icon>
          <span>
            Schließen
          </span>
        </button>
      </footer>
    </div>
  </form>
</template>

<script>
import FileSaver from "file-saver";
import Api from "../api";
import auth from "../auth";

export default {
  props: ["library", "batchid"],
  data() {
    return {
      sesid: auth.getSesId(),
      batch: null,
      requests: null,
      apiError: "",
      isLoading: false,
      isError: false
    };
  },
  computed: {},
  methods: {
    load: async function() {
      let vm = this;

      vm.isLoading = true;
      vm.apiError = "";

      let url = "list/requests/" + vm.batchid;
      url += "?library=" + encodeURIComponent(vm.library);

      try {
        const res = await Api.getJSON("get", url);
        vm.batch = res.batch;
        vm.requests = res.requests;
        vm.isError = false;
        vm.currentPage = 1;
      } catch (error) {
        if (error.response.status == 401) {
          vm.$router.replace({
            path: "/login",
            query: { reason: "sessionExpired", redirect: vm.$route.fullPath }
          });
        }
        vm.apiError = Api.getFirstError(error);
        vm.batch = null;
        vm.requests = null;
        vm.isError = true;
      }

      vm.isLoading = false;
    },
    downloadBatch: async function(format) {
      let vm = this;

      vm.isLoading = true;
      vm.apiError = "";

      let url = "get/batch/" + vm.batchid + "/" + format;
      url += "?library=" + encodeURIComponent(vm.library);

      let fn_l = vm.library.replace(/\//g, "_");
      let fn_b = vm.batchid.toString().padStart(6, "0");
      let filename = "wls-" + fn_l + "-" + fn_b + "." + format;

      try {
        const res = await Api.getBlob("post", url);
        let type = res.headers["content-type"];
        let blob = new Blob([res.data], {
          type: type
        });
        FileSaver.saveAs(blob, filename);
      } catch (error) {
        if (error.response.status == 401) {
          vm.$router.replace({
            path: "/login",
            query: { reason: "sessionExpired", redirect: vm.$route.fullPath }
          });
        }
        vm.apiError = Api.getFirstError(error);
      }

      vm.isLoading = false;
    },
    downloadRequest: async function(reqid, format) {
      let vm = this;

      vm.isLoading = true;
      vm.apiError = "";

      let url = "get/batch/" + vm.batchid + "/requests/" + reqid + "/" + format;
      url += "?library=" + encodeURIComponent(vm.library);

      let fn_l = vm.library.replace(/\//g, "_");
      let fn_b = vm.batchid.toString().padStart(6, "0");
      let filename = "wls-" + fn_l + "-" + fn_b + "-" + reqid + "." + format;

      try {
        const res = await Api.getBlob("post", url);
        let type = res.headers["content-type"];
        let blob = new Blob([res.data], {
          type: type
        });
        FileSaver.saveAs(blob, filename);
      } catch (error) {
        if (error.response.status == 401) {
          vm.$router.replace({
            path: "/login",
            query: { reason: "sessionExpired", redirect: vm.$route.fullPath }
          });
        }
        vm.apiError = Api.getFirstError(error);
      }

      vm.isLoading = false;
    },
    openBatch: function(format) {
      let vm = this;
      let url =
        "api/get/batch/" +
        vm.batchid +
        "/" +
        format +
        "?library=" +
        encodeURIComponent(vm.library) +
        "&sesid=" +
        encodeURIComponent(this.sesid);
      window.open(url, "_blank");
    },
    openRequest: function(reqid, format) {
      let vm = this;
      let url =
        "api/get/batch/" +
        vm.batchid +
        "/requests/" +
        reqid +
        "/" +
        format +
        "?library=" +
        encodeURIComponent(vm.library) +
        "&sesid=" +
        encodeURIComponent(this.sesid);
      window.open(url, "_blank");
    }
  },
  mounted: function() {
    this.load();
  }
};
</script>
